import { css } from '@emotion/core';

export const noAccessLogoContainerCSS = css`
    padding-top: 7.5rem;
    padding-bottom: 2.5rem;
`;

export const noAccessTextContainerCSS = css`
    max-width: 15rem;
    text-align: center;
`;
